exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-title-custom {\n  margin-top: 0px !important;\n}\n.portlet.light.bordered {\n  border: none !important;\n  padding-bottom: 0px;\n}\n.htc-center {\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/manage/dashboard1/dashboard1.component.css
// module id = 589
// module chunks = 0